<template>
    <b-modal
        v-model="modal"
        :id="'close-projects-modal'"
        :title="$t('group.close_project_on')"
        modal-class="apprentice-default-modal">
        <b-form-group>
            <div class="date">
                <b-form-group
                    label="Datum"
                    label-for="deadline-datepicker-input">
                    <template v-slot:label> Datum: <span class="required">*</span></template>
                    <b-form-datepicker
                        class="apprentice-date-picker btn-date-group"
                        id="start-datepicker-input"
                        v-model.lazy="deadline"
                        :config="dateConfig"
                        start-weekday="1"
                        now-button
                        reset-button
                        right
                        today-variant="primary"
                        nav-button-variant="primary"
                        locale="nl"
                        :aria-controls="$t('group.choose_date')"
                        label-reset-button="reset"
                        :label-no-date-selected="$t('group.no_date_selected')"
                        menu-class="datedropdown"
                        :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }">
                    </b-form-datepicker>
                </b-form-group>
                <b-form-group
                    label="Tijd"
                    label-for="deadline-timepicker-input">
                    <template v-slot:label> {{ $t('group.modals.time') }}: <span class="required">*</span></template>
                    <design-2021-apprentice-timepicker-component v-model.lazy="deadlineTime">
                    </design-2021-apprentice-timepicker-component>
                </b-form-group>
            </div>
        </b-form-group>
        <template #modal-footer>
            <b-button
                @click="cancel()"
                variant="outline-primary"
                >{{ $t('common.cancel') }}
            </b-button>
            <b-button
                class="remove"
                v-if="deadlineIn"
                @click="removeDeadline"
                variant="outline-danger">
                <i class="btn-remove"></i>{{ $t('group.modals.reopen') }}
            </b-button>
            <b-button
                id="ok"
                @click="onOk"
                variant="primary"
                >{{ $t('common.save') }}
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-close-projects-modal-component',
    props: ['deadlineIn'],
    data() {
        return {
            dateConfig: {
                format: 'DD-MM-YYYY',
                useCurrent: false,
            },
            timeConfig: {
                format: 'H:mm',
                useCurrent: false,
                labelCloseButton: this.$t('common.close'),
                noCloseButton: true,
                icons: {
                    close: 'fa fa-times-circle',
                },
            },
            modal: false,
            oldDeadline: null,
            deadline: null,
            deadlineTime: null,
        };
    },
    mounted() {
        this.oldDeadline = this.deadlineIn ? new Date(this.deadlineIn) : new Date();
        this.deadline = `${this.oldDeadline.getFullYear()}-${String(this.oldDeadline.getMonth() + 1).padStart(2, '0')}-${String(this.oldDeadline.getDate()).padStart(2, '0')}`;
        this.deadlineTime = `${String(this.oldDeadline.getHours()).padStart(2, '0')}:${String(this.oldDeadline.getMinutes()).padStart(2, '0')}`;
    },
    methods: {
        onOk() {
            this.$emit('close', this.deadline + ' ' + this.deadlineTime);
            this.modal = false;
        },
        removeDeadline() {
            this.$emit('remove');
            this.modal = false;
        },
        cancel() {
            this.modal = false;
        },
    },
};
</script>
<style scoped lang="scss">
.remove {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'eight');
}
</style>
